import React from "react";
import { Link } from "react-router-dom";
import { BackIcon } from "../../../icons";

const STATUS_MAP = {
    PENDING_APPROVAL: { label: "Request Pending", style: "tw:bg-[#F6BB2A]" },
    APPROVED: { label: "Request Approved", style: "tw:bg-[#3CAEA3]" },
    REJECTED: { label: "Request Rejected", style: "tw:bg-[#EA4335]" },
    UPDATED: { label: "Booking Updated", style: "tw:bg-[#F9EDD3] tw:!text-[#A3780F]" },
    DRAFT: { label: "Draft", style: "tw:bg-[#E8E8E8] tw:!text-[#7C7B7B]" },
};

const Header = ({ data }) => {
    const getStatusMeta = (data) => {
        const raw = String(data?.status || "").trim().toUpperCase();
        if (raw === "DRAFT") return STATUS_MAP.DRAFT;
        if (data?.requestType === "reschedule") {
            if (raw === "APPROVED" && !data?.responseBy) return STATUS_MAP.UPDATED;
            return STATUS_MAP[raw] || STATUS_MAP.PENDING_APPROVAL;
        }
        return { label: "Booking Cancelled", style: "tw:bg-[#EA4335]" };
    };

    const statusMeta = getStatusMeta(data);
    const title = data?.requestType === "reschedule" ? "Booking Modification Request" : "Booking Cancellation";

    return (
        <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-6 tw:pb-[28px] tw:lg:pb-[42px] tw:px-5 tw:pt-8">
            <Link
                to={"/admin/modification-requests"}
                className="tw:inline-flex tw:items-center tw:gap-[10px] tw:rounded-[5px] tw:border tw:border-[#e8e8e8] tw:bg-[#e8e8e8] tw:px-3 tw:py-2 tw:text-[#282828] tw:!no-underline"
            >
                <BackIcon color="#8D8D8D" width={7} height={10} />
                <span className="tw:!font-hanken-grotesk tw:text-[#282828] tw:text-[14px]">Back</span>
            </Link>
            <div className="tw:flex tw:flex-1 tw:items-center tw:justify-between tw:gap-4">
                <div className="tw:flex tw:flex-col">
                    <div className="tw:!font-hanken-grotesk tw:font-[500] tw:text-[14px] tw:text-[#7c7b7b]">
                        {`[Cart #${data.bookingId?.cartID || ''}・Booking #${data.bookingId?._id || ''}]`}
                    </div>
                    <div className="tw:!font-hanken-grotesk tw:text-[24px] tw:font-[500] tw:leading-normal tw:text-[#212529]">
                        {title}
                    </div>
                </div>
                <span
                    className={`tw:inline-flex tw:h-[45px] tw:items-center tw:justify-center tw:whitespace-nowrap tw:rounded-[5px] tw:px-6 tw:text-[15px] tw:leading-[22px] tw:text-white ${statusMeta.style}`}
                >
                    {statusMeta.label}
                </span>
            </div>
        </div>
    );
};

export default Header;
